/* Underlayers redesign — quick add, toast, gate drop teaser, product page */
(function () {
  if (window.UL) return;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-AU', { style: 'currency', currency: currency || 'AUD' }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function add(items) {
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        return r.json().then(function (d) {
          if (!r.ok) throw new Error(d.description || d.message || 'Could not add to cart');
          return d;
        });
      })
      .then(function () { return fetch(root + 'cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: cart, sourceId: 'underlayers', data: { source: 'underlayers', itemCount: cart.item_count } }
        }));
        return cart;
      });
  }

  var toastEl, toastTimer;
  function toast(title, sub, isError) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'ul-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.classList.toggle('is-error', !!isError);
    toastEl.innerHTML =
      '<div class="ul-toast__msg"><b>' + esc(title) + '</b><span>' + esc(sub) + '</span></div>' +
      (isError ? '' : '<div class="ul-toast__actions"><a href="' + root + 'cart">View cart</a><a href="' + root + 'checkout">Checkout</a></div>');
    requestAnimationFrame(function () { toastEl.classList.add('is-open'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-open'); }, 3500);
  }

  window.UL = { add: add, toast: toast, money: money, esc: esc };

  /* ---------- Quick add (home cards) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ul-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    btn.classList.add('is-loading');
    add([{ id: Number(btn.dataset.ulAdd), quantity: 1 }])
      .then(function () {
        var group = btn.closest('.ul-card__sizes');
        if (group) group.querySelectorAll('.is-added').forEach(function (b) { b.classList.remove('is-added'); });
        btn.classList.add('is-added');
        toast('Added to cart', btn.dataset.ulLabel || '');
      })
      .catch(function (err) { toast('Couldn’t add that', err.message, true); })
      .then(function () { btn.classList.remove('is-loading'); });
  });

  /* ---------- Gate drop teaser ---------- */
  function initGate(scope) {
    (scope || document).querySelectorAll('[data-ul-gate]').forEach(function (gate) {
      if (gate.dataset.ready) return;
      gate.dataset.ready = '1';
      var board = gate.querySelector('[data-ul-gate-board]');
      var head = gate.querySelector('[data-ul-gate-head]');
      var sub = gate.querySelector('[data-ul-gate-sub]');
      var bestEl = gate.querySelector('[data-ul-gate-best]');
      var state = 'idle', timer = null, t0 = 0, best = null;
      try { best = Number(localStorage.getItem('ul-gate-best')) || null; } catch (e) {}
      if (best) bestEl.textContent = best + 'ms';

      function set(s, b, h, t) {
        state = s; gate.dataset.state = s;
        board.textContent = b; head.textContent = h; sub.textContent = t;
      }
      function go() {
        if (state === 'set') { clearTimeout(timer); set('jumped', '!', 'Jumped the gate', 'Too early — tap to line up again.'); return; }
        if (state === 'drop') {
          var ms = Math.round(performance.now() - t0);
          if (!best || ms < best) { best = ms; try { localStorage.setItem('ul-gate-best', ms); } catch (e) {} }
          bestEl.textContent = best + 'ms';
          var msg = ms < 180 ? 'HOLESHOT. Play the full test to post it on the leaderboard.'
            : ms < 250 ? 'Top-5 start. Tap to go again.'
            : ms < 350 ? 'Mid-pack. Tap to go again.' : 'Back of the pack — tap to go again.';
          set('result', ms < 180 ? '1st' : ms < 250 ? 'TOP 5' : 'GO', ms + 'ms', msg);
          return;
        }
        set('set', '5', 'Eyes on the gate…', 'Board is sideways — it could drop any second.');
        timer = setTimeout(function () { t0 = performance.now(); set('drop', 'GO', 'GO!', 'Tap now!'); }, 1400 + Math.random() * 2400);
      }
      gate.addEventListener('pointerdown', function (e) { e.preventDefault(); go(); });
      gate.addEventListener('keydown', function (e) { if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); go(); } });
    });
  }

  /* ---------- Product page ---------- */
  function initPdp(scope) {
    (scope || document).querySelectorAll('[data-ul-pdp]').forEach(function (pdp) {
      if (pdp.dataset.ready) return;
      pdp.dataset.ready = '1';
      var currency = pdp.dataset.currency;
      var variants = JSON.parse(pdp.querySelector('[data-ul-variants]').textContent);
      var guideRows = {};
      var guideEl = pdp.querySelector('[data-ul-guide]');
      pdp.querySelectorAll('[data-ul-row]').forEach(function (r) { guideRows[r.dataset.ulRow] = r; });
      var groups = Array.prototype.slice.call(pdp.querySelectorAll('[data-ul-option]'));
      var sel = groups.map(function (g) { var b = g.querySelector('[aria-pressed="true"]'); return b ? b.dataset.ulValue : null; });
      var form = pdp.querySelector('form[action*="/cart/add"]');
      var idInput = form.querySelector('input[name="id"]');
      var qtyInput = pdp.querySelector('[data-ul-qty]');
      var addBtn = pdp.querySelector('[data-ul-addbtn]');
      var errEl = pdp.querySelector('[data-ul-error]');
      var priceEl = pdp.querySelector('[data-ul-price]');
      var fitEl = pdp.querySelector('[data-ul-fit]');
      var fitDefault = fitEl ? fitEl.textContent : '';
      var sticky = pdp.querySelector('[data-ul-sticky]');
      var stickyBtn = sticky && sticky.querySelector('button');
      var stickyMeta = sticky && sticky.querySelector('[data-ul-sticky-meta]');
      var track = pdp.querySelector('[data-ul-track]');
      var thumbs = Array.prototype.slice.call(pdp.querySelectorAll('[data-ul-thumb]'));
      var countEl = pdp.querySelector('[data-ul-count]');
      var drawer = pdp.querySelector('[data-ul-drawer]');

      function match() {
        if (sel.some(function (v) { return v == null; })) return null;
        return variants.find(function (v) { return v.options.every(function (o, i) { return o === sel[i]; }); }) || null;
      }

      function markAvailability() {
        groups.forEach(function (g, gi) {
          g.querySelectorAll('[data-ul-value]').forEach(function (b) {
            var val = b.dataset.ulValue;
            var ok = variants.some(function (v) {
              if (!v.available || v.options[gi] !== val) return false;
              return sel.every(function (s, si) { return si === gi || s == null || v.options[si] === s; });
            });
            b.classList.toggle('is-unavailable', !ok);
          });
        });
      }

      function update() {
        var v = match();
        var qty = Math.max(1, Number(qtyInput && qtyInput.value) || 1);
        idInput.value = v ? v.id : '';
        groups.forEach(function (g, gi) {
          var out = g.querySelector('[data-ul-opt-value]');
          if (out) out.textContent = sel[gi] || 'Select';
        });
        markAvailability();
        var label, ready = false;
        if (!v) {
          var missing = groups.filter(function (g, gi) { return sel[gi] == null; }).map(function (g) { return g.dataset.ulName.toLowerCase(); });
          label = 'Select ' + (missing[0] || 'an option');
        } else if (!v.available) {
          label = 'Sold out';
        } else {
          label = 'Add to cart — ' + money(v.price * qty, currency);
          ready = true;
        }
        addBtn.textContent = label;
        addBtn.dataset.ready = ready ? 'true' : 'false';
        if (stickyBtn) { stickyBtn.textContent = ready ? 'Add to cart' : label; }
        if (v && priceEl) {
          priceEl.innerHTML = money(v.price, currency) + (v.compare_at_price > v.price ? '<s>' + money(v.compare_at_price, currency) + '</s>' : '');
        }
        if (stickyMeta) stickyMeta.textContent = (v ? money(v.price, currency) : '') + (sel.filter(Boolean).length ? ' · ' + sel.filter(Boolean).join(' / ') : '');
        var sizeIdx = groups.findIndex(function (g) { return g.dataset.ulGuide === 'true'; });
        Object.keys(guideRows).forEach(function (k) { guideRows[k].classList.toggle('is-active', sizeIdx > -1 && sel[sizeIdx] === k); });
        if (fitEl) {
          var row = sizeIdx > -1 && guideRows[sel[sizeIdx]];
          fitEl.textContent = row && row.dataset.ulFit ? row.dataset.ulFit : fitDefault;
        }
        if (v && v.featured_media && track) {
          var slide = pdp.querySelector('[data-ul-media-id="' + v.featured_media.id + '"]');
          if (slide) track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        }
        if (v && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
        if (errEl) errEl.textContent = '';
        return v;
      }

      groups.forEach(function (g, gi) {
        g.addEventListener('click', function (e) {
          var b = e.target.closest('[data-ul-value]');
          if (!b) return;
          sel[gi] = b.dataset.ulValue;
          g.querySelectorAll('[data-ul-value]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          g.classList.remove('is-nudge');
          update();
        });
      });

      pdp.querySelectorAll('[data-ul-guide-toggle]').forEach(function (t) {
        t.addEventListener('click', function () {
          var open = guideEl.hidden;
          guideEl.hidden = !open;
          pdp.querySelectorAll('[data-ul-guide-toggle]').forEach(function (x) {
            x.setAttribute('aria-expanded', open ? 'true' : 'false');
            var lbl = x.querySelector('[data-ul-guide-label]');
            if (lbl) lbl.textContent = open ? 'Hide size guide' : 'Size guide';
          });
        });
      });
      if (guideEl && window.location.hash === '#ul-size-guide') { guideEl.hidden = false; }

      pdp.querySelectorAll('[data-ul-step]').forEach(function (b) {
        b.addEventListener('click', function () {
          qtyInput.value = Math.max(1, (Number(qtyInput.value) || 1) + Number(b.dataset.ulStep));
          update();
        });
      });
      if (qtyInput) qtyInput.addEventListener('change', update);

      thumbs.forEach(function (t, i) {
        t.addEventListener('click', function () {
          var slide = track.children[i];
          if (slide) track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        });
      });
      if (track) {
        track.addEventListener('scroll', function () {
          var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
          thumbs.forEach(function (t, ti) { t.setAttribute('aria-current', ti === i ? 'true' : 'false'); });
          if (countEl) countEl.textContent = (i + 1) + ' / ' + track.children.length;
        }, { passive: true });
      }

      function openDrawer(cart) {
        if (!drawer) return;
        drawer.querySelector('[data-ul-drawer-count]').textContent = cart.item_count;
        drawer.querySelector('[data-ul-drawer-total]').textContent = money(cart.total_price, cart.currency || currency);
        drawer.querySelector('[data-ul-drawer-lines]').innerHTML = cart.items.map(function (it) {
          var img = it.image ? it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=160' : '';
          return '<div class="ul-line">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="76" height="92">' : '<span style="width:76px;height:92px;flex:0 0 76px;background:#EDEDEA"></span>') +
            '<div><b>' + esc(it.product_title) + '</b><div class="ul-line__meta">' + esc(it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '') + (it.quantity > 1 ? ' · Qty ' + it.quantity : '') + '</div><b>' + money(it.final_line_price, cart.currency || currency) + '</b></div></div>';
        }).join('');
        drawer.hidden = false;
        document.documentElement.style.overflow = 'hidden';
        drawer.querySelector('[data-ul-drawer-close].ul-drawer__close').focus();
      }
      function closeDrawer() {
        drawer.hidden = true;
        document.documentElement.style.overflow = '';
        addBtn.focus();
      }
      if (drawer) {
        drawer.querySelectorAll('[data-ul-drawer-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
        drawer.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
      }

      function submit() {
        var v = update();
        if (!v) {
          groups.forEach(function (g, gi) { if (sel[gi] == null) g.classList.add('is-nudge'); });
          if (guideEl && groups.some(function (g) { return g.dataset.ulGuide === 'true'; })) {
            guideEl.hidden = false;
          }
          var first = groups.find(function (g, gi) { return sel[gi] == null; });
          if (first) first.scrollIntoView({ behavior: 'smooth', block: 'center' });
          if (fitEl) fitEl.textContent = 'Pick your ' + (first ? first.dataset.ulName.toLowerCase() : 'option') + ' first — use the size guide if you’re unsure.';
          return;
        }
        if (!v.available) return;
        addBtn.disabled = true;
        add([{ id: v.id, quantity: Math.max(1, Number(qtyInput.value) || 1) }])
          .then(openDrawer)
          .catch(function (err) { if (errEl) errEl.textContent = err.message; })
          .then(function () { addBtn.disabled = false; });
      }
      form.addEventListener('submit', function (e) { e.preventDefault(); submit(); });
      if (stickyBtn) stickyBtn.addEventListener('click', submit);

      if (sticky && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          sticky.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
        }).observe(addBtn);
      }

      update();
    });
  }

  function initAll(scope) { initGate(scope); initPdp(scope); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
